import dataAttributeWhitelist from '../constants/data-attribute-whitelist';

export function normaliseDataAttributes(dataAttributes) {
  if (!dataAttributes) return null;

  return Object.keys(dataAttributes)
    .filter(dataAttribute => dataAttributeWhitelist.includes(dataAttribute))
    .reduce(
      (obj, key) => ({
        ...obj,
        [key]: dataAttributes[key],
      }),
      {},
    );
}
